import * as React from "react";

const SelectedDotIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350.16 350.16" {...props}>
		<path d="M341.69 175.35c0 89.99-73.15 163.56-164.07 163.05-89.68-.5-162.97-73.62-162.07-164.79.87-89.66 74.16-162.2 164.65-161.36 89.4.83 161.49 73.59 161.48 163.09Z" />
	</svg>
);

export default SelectedDotIcon;
